// import { useSubscription } from '@apollo/client'; // Temporarily disabled

import { useSalonStore } from "@/lib/store/salon";
// Subscriptions temporarily disabled - requires WebSocket setup
// import {
//   USER_NOTIFICATION_RECEIVED,
//   USER_NOTIFICATION_STATS_UPDATED,
//   GET_USER_NOTIFICATIONS,
//   // Legacy imports for backward compatibility
//   NOTIFICATION_RECEIVED,
//   NOTIFICATION_STATS_UPDATED,
//   GET_NOTIFICATIONS,
// } from '@/graphql/notifications';
import type { UserNotification } from "../../types";

interface UseNotificationSubscriptionOptions {
  salonId?: string | null;
  onNotificationReceived?: (notification: UserNotification) => void;
  onStatsUpdated?: () => void;
  showToast?: boolean;
}

export const useNotificationSubscription = (options: UseNotificationSubscriptionOptions = {}) => {
  const { currentSalon } = useSalonStore();
  const _salonId = options.salonId !== undefined ? options.salonId : currentSalon?.id || null;

  // Subscription for new notifications - temporarily disabled
  // const { data: notificationData } = useSubscription(USER_NOTIFICATION_RECEIVED, {
  //   variables: {
  //     salonId,
  //   },
  //   skip: salonId === null || !user?.id,
  //   onData: ({ data, client }) => {
  //     if (data.data?.notificationReceived) {
  //       const notification = data.data.notificationReceived as UserNotification;
  //
  //       // Update Apollo cache with new notification
  //       try {
  //         const existingData = client.readQuery({
  //           query: GET_USER_NOTIFICATIONS,
  //           variables: {
  //             salonId,
  //             first: 20,
  //           },
  //         }) as any;

  //         if (existingData?.getNotifications) {
  //           // Add new notification to the beginning of the list
  //           const newEdge = {
  //             node: notification,
  //             cursor: Buffer.from(notification.createdAt).toString('base64'),
  //             __typename: 'UserNotificationEdge',
  //           };

  //           const updatedConnection = {
  //             ...existingData.getNotifications,
  //             edges: [newEdge, ...existingData.getNotifications.edges],
  //             __typename: 'UserNotificationConnection',
  //           };

  //           client.writeQuery({
  //             query: GET_USER_NOTIFICATIONS,
  //             variables: {
  //               salonId,
  //               first: 20,
  //             },
  //             data: {
  //               getNotifications: updatedConnection,
  //             },
  //           });
  //         }
  //       } catch (error) {
  //         // Cache update failed - this is okay, just log for debugging
  //         console.debug('Failed to update cache with new notification:', error);
  //       }
  //
  //       // Show toast notification for unread notifications
  //       if (showToast && !notification.isRead) {
  //         toast({
  //           title: notification.title,
  //           description: notification.message,
  //           duration: 5000,
  //           action: notification.actionUrl ? {
  //             label: notification.actionText || 'View',
  //             onClick: () => window.open(notification.actionUrl, '_blank'),
  //           } : undefined,
  //         });
  //       }

  //       // Call custom handler if provided
  //       if (onNotificationReceived) {
  //         onNotificationReceived(notification);
  //       }
  //     }
  //   },
  //   onError: (error) => {
  //     console.error('Notification subscription error:', error);
  //     // Handle authentication errors gracefully
  //     if (error.message?.includes('authorization') || error.message?.includes('Authentication')) {
  //       console.warn('Notification subscription authentication failed - user may need to re-login');
  //     }
  //   },
  // });

  // Subscription for stats updates - temporarily disabled
  // const { data: statsData } = useSubscription(USER_NOTIFICATION_STATS_UPDATED, {
  //   variables: {
  //     salonId,
  //   },
  //   skip: salonId === null || !user?.id,
  //   onData: ({ data }) => {
  //     if (data.data?.notificationStatsUpdated && onStatsUpdated) {
  //       onStatsUpdated();
  //     }
  //   },
  //   onError: (error) => {
  //     console.error('Notification stats subscription error:', error);
  //     // Handle authentication errors gracefully
  //     if (error.message?.includes('authorization') || error.message?.includes('Authentication')) {
  //       console.warn('Notification stats subscription authentication failed - user may need to re-login');
  //     }
  //   },
  // });

  return {
    notificationData: null, // Temporarily disabled
    statsData: null, // Temporarily disabled
    isConnected: false, // Subscriptions are disabled
  };
};
